import Marquee from "react-fast-marquee";

const sources = [
  "Dallas Foodies",
  "Asian Grub in DFDUB",
  "Black Owned Restaurants DFW",
  "r/dallasfood",
  "DFW Food Adventures",
  "Dallas Food Lovers",
  "Hidden Gems Dallas",
  "Best Eats DFW",
  "Dallas Foodie Finds",
  "r/FortWorth",
];

const Dot = () => (
  <span className="mx-10 text-[#FF641E] text-lg leading-none">·</span>
);

const SocialProofTicker = () => {
  return (
    <div
      data-testid="social-proof-ticker"
      className="py-5 border-y border-white/[0.06] overflow-hidden"
    >
      <Marquee speed={38} gradient={false} pauseOnHover>
        {sources.map((source, i) => (
          <span key={i} className="flex items-center">
            <span className="font-manrope text-[#8A8A93] uppercase tracking-[0.18em] text-xs sm:text-sm whitespace-nowrap">
              Sourced from {source}
            </span>
            <Dot />
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default SocialProofTicker;
